import * as React from "react";
import styles from "./ForgetPass.module.css";

import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, styled, ThemeProvider } from "@mui/material/styles";
import logo from "../Assets/logo.png";
import Parse from "../../API/ParseServer";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Header from "../../Components/Layout/Header";
import Footer from "../../Components/Layout/Footer";

const defaultTheme = createTheme();
const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#863a18",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#863a18",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#863a18",
    },
    "&:hover fieldset": {
      borderColor: "#863a18",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#863a18",
    },
  },
});
const EditProfile = () => {
  const [user, setUser] = React.useState<any>();

  const [errorMessage, setErrorMessage] = React.useState("");
  const [successMessage, setSuccessMessage] = React.useState("");

  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = React.useState<String | null>(null);
  const phoneNumberChangeHandler = (event: any) => {
    setPhoneNumber(event.target.value);
  };
  function validatePassword(pw: any) {
    return (
      /[A-Z]/.test(pw) &&
      /[a-z]/.test(pw) &&
      /[0-9]/.test(pw) &&
      /[^A-Za-z0-9]/.test(pw) &&
      pw.length > 7
    );
  }
  const validMobile =
    /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/;
  useEffect(() => {
    const currentUser = Parse.User.current();
    if (currentUser) {
      setUser(currentUser);
      setPhoneNumber(currentUser.get("phoneNumber"));
    } else {
      navigate("/");
      setErrorMessage("");
    }
  }, []);
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    setSuccessMessage("");
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const password = String(data.get("password"));
    const confirmPassword = String(data.get("confirm-password"));
    const phoneNumber = String(data.get("phone-number"));
    if (!validMobile.test(String(phoneNumber)))
      setErrorMessage("Invalid phone number");
    else if (!password && !confirmPassword) {
      setErrorMessage("");
      try {
        user.set("phoneNumber", Number(phoneNumber));
        await user.save();
        setSuccessMessage("Your phone number successfully changed");
      } catch (error: any) {
        console.log(error.message);
        setErrorMessage("error.message");
      }
    } else if (!validatePassword(password))
      setErrorMessage(
        "Paint your password with 8+ strokes and at least one special symbol (e.g.,!@#$%^&*)"
      );
    else if (!(password === confirmPassword))
      setErrorMessage(
        "Uh-oh! Your passwords are clashing like clashing colours. Try again!"
      );
    else {
      setErrorMessage("");

      try {
        user.set("phoneNumber", Number(phoneNumber));
        user.setPassword(password);
        await user.save();
        setSuccessMessage("Your changes successfully saved");
      } catch (error: any) {
        console.log(error.message);
        setErrorMessage(error.message);
      }
    }
  };

  return (
    <React.Fragment>
      <ThemeProvider theme={defaultTheme}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          {user && (
            <Box
              sx={{
                mt: 5,
                mb: 10,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography component="h1" variant="h5" sx={{ mb: 5 }}>
                Edit Profile
              </Typography>
              <Typography variant="h6" sx={{ width: "100%", mb: 1 }}>
                Name: {user.get("firstName") + " " + user.get("lastName")}
              </Typography>
              <Typography variant="h6" sx={{ width: "100%", mb: 2 }}>
                Email: {user.get("username")}
              </Typography>
              <Box component="form" noValidate onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <CssTextField
                      required
                      fullWidth
                      id="phone-number"
                      label="Phone number"
                      name="phone-number"
                      autoComplete="phone-number"
                      value={phoneNumber}
                      defaultValue={phoneNumber}
                      onChange={phoneNumberChangeHandler}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CssTextField
                      required
                      fullWidth
                      name="password"
                      label="Password"
                      type="password"
                      id="password"
                      autoComplete="new-password"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CssTextField
                      required
                      fullWidth
                      name="confirm-password"
                      label="Confirm Password"
                      type="password"
                      id="confirm-password"
                      autoComplete="new-password"
                    />
                  </Grid>
                </Grid>
                <button className={styles.button}>Save Changes</button>
                {errorMessage && (
                  <Typography
                    sx={{
                      textAlign: "center",
                      my: 2,
                      color: "#862e18",
                      fontWeight: "bold",
                    }}
                  >
                    {errorMessage}
                  </Typography>
                )}
                {successMessage && (
                  <Typography
                    sx={{
                      textAlign: "center",
                      my: 2,
                      color: "#862e18",
                      fontWeight: "bold",
                    }}
                  >
                    {successMessage}
                  </Typography>
                )}
              </Box>
            </Box>
          )}
        </Container>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default EditProfile;
